import React from "react";
import CircularProgress from "@mui/material/CircularProgress";

const LoadingContent = () => <CircularProgress variant="indeterminate" />;

export default LoadingContent;
